import { Autoplay, Navigation, Pagination } from 'swiper';
import { IOffers, Renewal } from 'interface/offers';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from 'react';

import CardRenewal from './CardRenewal';
import { makeStyles, alpha } from '@material-ui/core';
import { fetchOffers } from 'services/offer';
import UpsellCard from './UpsellCard/index';
import { useFlag } from 'hooks/useFlag';
import { RENEWAL_FEATURE } from 'settings';

interface IRenewalSlider {
  lessonId: string;
}

const useStyles = makeStyles((theme) => ({
  slider: {
    paddingLeft: '4vw',
    paddingRight: '4vw',
    paddingBottom: '10px',
    borderRadius: 8,
    [theme.breakpoints.down(780)]: {
      flexDirection: 'column',
      paddingLeft: 0,
      paddingRight: 0,
    },
    '& .swiper-pagination': {
      bottom: '0',
      display: 'none',
      [theme.breakpoints.down(780)]: {
        display: 'block',
      },

      '& .swiper-pagination-bullet': {
        backgroundColor: '#fff',
      },
    },
    '& .swiper-button-prev': {
      left: 0,
    },
    '& .swiper-button-prev, & .swiper-button-next': {
      height: 260,
      width: 50,
      top: 0,
      right: 0,
      cursor: 'pointer',
      background: alpha(theme.palette.neutrals.black, 0.7),
      [theme.breakpoints.down(780)]: {
        display: 'none',
      },
    },
  },
  sliderItem: {
    width: 'max-content',
    [theme.breakpoints.down(780)]: {
      maxWidth: '330px',
    },
    [theme.breakpoints.down(446)]: {
      maxWidth: '280px',
    },
  },
}));

export const OfferCarousel = ({ lessonId }: IRenewalSlider) => {
  const [listOffers, setListOffers] = useState<IOffers>();
  const clasess = useStyles();
  const hasFlag = useFlag(RENEWAL_FEATURE);

  useEffect(() => {
    fetchOffers(lessonId).then((response) => {
      setListOffers(response && response[0]);
    });
  }, [hasFlag, lessonId]);

  return (
    <Swiper
      slidesPerView={'auto'}
      navigation={true}
      spaceBetween={10}
      modules={[Navigation, Autoplay, Pagination]}
      pagination={{
        clickable: true,
      }}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      className={clasess.slider}
    >
      {listOffers &&
        listOffers?.renewal?.map((renewalItem: Renewal) => (
          <SwiperSlide className={clasess.sliderItem} style={{}}>
            <CardRenewal renewal={renewalItem} renewals={listOffers.renewal} />
          </SwiperSlide>
        ))}
      {listOffers?.upsell && (
        <SwiperSlide className={clasess.sliderItem}>
          <UpsellCard {...listOffers.upsell} />
        </SwiperSlide>
      )}
    </Swiper>
  );
};
